import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { RouterModule } from '@angular/router';
import { HeaderService } from './header/header.service';

@NgModule({
  declarations: [
    // SidebarComponent, 
    // FooterComponent,
    // HeaderComponent
  ],
  imports: [
    CommonModule,
    NgMultiSelectDropDownModule.forRoot(),
    RouterModule
  ],
  exports: [
    // SidebarComponent,
    // FooterComponent,
    // HeaderComponent
  ],
  providers: [
    // HeaderService
  ]
})
export class CoreModule { }
